/**
 * Shared product-tile hero image chrome (RangeProductTile, Contentful Product Tiles).
 * Want It Sooner (`InstockProductTile`) keeps legacy swiper — excluded from this theme.
 */

export const PRODUCT_TILE_IMAGE_BEHAVIOR_SX = {
  '&.product-tile-image--hover-swap': {
    cursor: 'pointer',
  },
  '&.product-tile-image--carousel-multi .swiper-button-next, &.product-tile-image--carousel-multi .swiper-button-prev':
    {
      opacity: 0,
      transition: 'opacity 0.2s ease',
    },
  '&.product-tile-image--in-carousel-slide.product-tile-image--carousel-multi .swiper-button-next, &.product-tile-image--in-carousel-slide.product-tile-image--carousel-multi .swiper-button-prev, &.product-tile-image--in-carousel-slide.product-tile-image--swipe .swiper-button-next, &.product-tile-image--in-carousel-slide.product-tile-image--swipe .swiper-button-prev':
    {
      opacity: 1,
    },
  '@media (hover: hover) and (pointer: fine)': {
    '&.product-tile-image--carousel-multi:hover .swiper-button-next, &.product-tile-image--carousel-multi:hover .swiper-button-prev':
      {
        opacity: 1,
      },
    '&.product-tile-image--in-carousel-slide.product-tile-image--carousel-multi:hover .swiper-button-next, &.product-tile-image--in-carousel-slide.product-tile-image--carousel-multi:hover .swiper-button-prev, &.product-tile-image--in-carousel-slide.product-tile-image--swipe:hover .swiper-button-next, &.product-tile-image--in-carousel-slide.product-tile-image--swipe:hover .swiper-button-prev':
      {
        opacity: 1,
      },
    '&.product-tile-image--hover-swap:hover .product-tile-image__hover-primary': {
      opacity: 0,
    },
    '&.product-tile-image--hover-swap:hover .product-tile-image__hover-secondary': {
      opacity: 1,
    },
  },
};

export const PRODUCT_TILE_HOVER_SWAP_WRAPPER = {
  height: '100%',
  position: 'relative',
  width: '100%',
};

export const PRODUCT_TILE_HOVER_SWAP_LAYER = {
  alignItems: 'center',
  display: 'flex',
  height: '100%',
  inset: 0,
  justifyContent: 'center',
  position: 'absolute',
  transition: 'opacity 0.25s ease',
  width: '100%',
};

export const PRODUCT_TILE_HOVER_SWAP_PRIMARY = {
  opacity: 1,
  zIndex: 1,
};

export const PRODUCT_TILE_HOVER_SWAP_SECONDARY = {
  opacity: 0,
  zIndex: 0,
};

/** GalleryVideoSlide container on PLP tiles — no controls, no black letterbox. */
export const PRODUCT_TILE_VIDEO_CONTAINER = {
  alignItems: 'center',
  display: 'flex',
  height: '100%',
  justifyContent: 'center',
  minHeight: '100%',
  position: 'relative',
  width: '100%',
  sx: {
    '& .amb-video': {
      alignSelf: 'center',
      maxHeight: '100%',
      maxWidth: '100%',
      width: '100%',
    },
    '& .amb-video.landscape iframe, & .amb-video.landscape video, & .amb-video.portrait iframe, & .amb-video.portrait video':
      {
        height: '100%',
        left: 0,
        pointerEvents: 'none',
        width: '100%',
      },
  },
};
